import { TranslateService } from '@ngx-translate/core';

export interface IPermissionViewModel {
    prefix: 'sys' | 'geral' | 'hw' | 'auto_fleet';
    key: string;
    active?: boolean;
    label?: string;
    description?: string;
    affectingRoles: string[];
}
export class PermissionViewModel implements IPermissionViewModel {
    public prefix!: 'sys' | 'geral' | 'hw' | 'auto_fleet';
    public key!: string;
    public active?: boolean;
    public label?: string;
    public description?: string;
    public affectingRoles: string[] = [];

    constructor(input: Partial<IPermissionViewModel>) {
        Object.assign(this, input);
    }

    /*
    public static Create(
        key: string,
        active: boolean,
        translateService: TranslateService
    ): PermissionViewModel {

        const translateKey = `PERMISSIONS.PERMISSION.${key}`;
        const translateKeyDescription = translateKey + "_DESCRIPTION";
        let description = translateService.instant(translateKeyDescription);
        if (description == translateKeyDescription) description = null;

        return new PermissionViewModel(
            key,
            active,
            translateService.instant(translateKey),
            description
        );
    }

    */
}
